
module.exports = {
    styles:{
        'infw-yodlee-how-icons-area' : 'infw-with-2-icons', 
        'infw-yodlee-how-badge'      : '',
        'infw-dialog-body'           : 'infw-hbox',
        'infw-dialog-icons'          : '',
        'infw-dialog-text'           : 'body-1 text-align-left',

        'infw-yodlee-how-container3'             : '',
        'infw-yodlee-how-subtitle'               : 'infw-font-bs margin-0-b text-align-left',
        // keep compatibility of old DOM
        'infw-yodlee-how-container1'             : 'container text-align-center',
        'infw-yodlee-how-container2'             : 'card-body pad-3-lr printable',
        'infw-yodlee-how-section'                : '',
        'infw-list-text-rws'                     : 'pad-1 heading-3 dls-core-blue-01 printable',
        'infw-list-item'                         : 'tnc-list-item',

        'infw-yodlee-tnc-confirm-container1'     : 'card-body',
        'infw-yodlee-tnc-confirm-container2'     : 'row',
        'infw-yodlee-tnc-confirm-container-chk'  : 'col-xs-1',
        'infw-yodlee-tnc-confirm-container-label': 'infw-small-desc infw-small-desc-13 col-xs-11 pad-1-lr',
        'infw-yodlee-tnc-links'                  : 'card-body pad-3-lr text-align-center',
        'infw-checkbox'                          : '',
        'dummy':''        
    },

    labels:{
        en: {

        },
        es: {

        }
    }
};



// WEBPACK FOOTER //
// ./application/src/themes/intl_eapply.js